import React, { useState } from 'react';
import { Helmet } from "react-helmet";
import PageBanner from "../../components/body/PageBanner";
import { APP_NAME } from "../../utils/appName";
import "../../assets/css/convocatoria-modern.css";
import { convocatoriasCASData } from "../../utils/dataConvocatorias";

function ConvocatoriaCAS() {
   const [filterYear, setFilterYear] = useState("2026");
   const [filterMonth, setFilterMonth] = useState("TODOS");

   const filteredData = convocatoriasCASData.filter(item => {
      const periodUpper = item.period.toUpperCase();
      const matchesYear = filterYear === "TODOS" || periodUpper.includes(filterYear);
      const matchesMonth = filterMonth === "TODOS" || periodUpper.includes(filterMonth);
      return matchesYear && matchesMonth;
   });

   return (
      <>
         <Helmet>
            <title>Convocatoria CAS - {APP_NAME}</title>
         </Helmet>

         <PageBanner
            title="Oportunidades Laborales"
            subtitle="Convocatorias CAS"
            parent_link="/convocatoria-cas"
            subtitle_link=""
         />

         <div className="convocatoria-container tp-service-3-area pt-80 pb-80" style={{ backgroundColor: "#f9fbfe" }}>
            <div className="container">

               <div className="modern-welcome-card glass-panel mb-5">
                  <div className="d-flex align-items-center mb-3 border-bottom pb-3">
                     <i className="fa-solid fa-briefcase fa-2x text-primary me-3"></i>
                     <h4 className="mb-0 fw-bold clr-primary">Portal de Selección de Personal</h4>
                  </div>
                  
                  <p className="mb-4" style={{ fontSize: '15px', color: '#4a4a4a' }}>
                     Bienvenidos al portal de Selección de Personal de la Municipalidad Distrital de la Libertad de Pallán. Para participar en nuestras convocatorias para la <strong>Contratación Administrativa de Servicios (CAS)</strong>, le pedimos leer atentamente y seguir las instrucciones detalladas a continuación, así como lo estipulado en las bases de cada concurso respectivo.
                  </p>
                  
                  <div className="mb-4">
                     <h6 className="fw-bold mb-2">INSTRUCCIONES</h6>
                     <p className="mb-2">Para participar en los procesos de convocatoria de <strong>Contrataciones Administrativas de Servicios (CAS)</strong>, el postulante debe de seguir los siguientes pasos:</p>
                     <ol className="mb-3 ps-3" style={{ fontSize: '14.5px' }}>
                        <li className="mb-2">
                           <strong>Descargar:</strong>
                           <ul className="mb-0 mt-1 ps-4 text-muted" style={{ listStyleType: 'circle' }}>
                              <li>Bases</li>
                              <li>Anexos del 01 al 07</li>
                           </ul>
                        </li>
                        <li className="mb-2">Adjuntar la documentación sustentatoria en copia simple y foliada, conforme a lo solicitado en los requisitos mínimos del postulante.</li>
                        <li className="mb-2">La presentación de la documentación será de acuerdo a lo establecido en las Bases del Proceso de Selección respectivo.</li>
                        <li className="mb-1">El postulante es responsable de verificar en el portal institucional de la Municipalidad Distrital de la Libertad de Pallán, los resultados parciales y finales publicados de cada etapa.</li>
                     </ol>
                  </div>
                  
                  <div className="mt-4 mb-3 p-3 bg-white rounded shadow-sm border-start border-4 border-primary">
                     <h6 className="fw-bold text-primary mb-2">FORMATOS PARA COMPLETAR POR GANADORES:</h6>
                     <p className="mb-2">Las personas que fueron elegidas GANADORES deberán adjuntar los siguientes documentos (dando click sobre el enlace) y seran entregados a la firma de Contrato:</p>
                     <ol className="mb-3 ps-3" style={{ fontSize: '14px' }}>
                        <li className="mb-1">Descargar la ficha de datos personales: <a href="#" className="fw-bold text-decoration-none">(Ficha de datos personales)</a></li>
                        <li className="mb-1">Descargar las Declaraciones juradas adicionales: <a href="#" className="fw-bold text-decoration-none">(Declaraciones juradas adicionales)</a></li>
                        <li className="mb-1">Descargar el Formato de cuenta de ahorro: <a href="#" className="fw-bold text-decoration-none">(Formato de cuenta de ahorro)</a></li>
                     </ol>
                     <p className="mb-0 fw-bold text-danger" style={{ fontSize: '13px' }}>
                        SE SOLICITA AL POSTULANTE QUE HAGA LECTURA A LA TOTALIDAD DE LAS HOJAS QUE COMPRENDE EL ARCHIVO PDF DE LAS BASES DE LA CONVOCATORIA A LA CUAL SE PRESENTA.
                     </p>
                  </div>

                  <p className="mb-0 text-muted mt-3 pt-3 border-top"><small>* Los Currículos Vitae presentados no serán devueltos a los postulantes por formar parte del acervo documentario del proceso.</small></p>
               </div>

               <div className="filters-section d-flex justify-content-between align-items-center mb-4">
                  <h5 className="mb-0 fw-bold clr-primary">{filteredData.length} convocatorias registradas</h5>
                  <div className="d-flex gap-3">
                     <select className="modern-select" value={filterYear} onChange={e => setFilterYear(e.target.value)}>
                        <option value="2026">2026</option>
                        <option value="2025">2025</option>
                        <option value="2024">2024</option>
                     </select>
                     <select className="modern-select" value={filterMonth} onChange={e => setFilterMonth(e.target.value)}>
                        <option value="TODOS">TODOS LOS MESES</option>
                        <option value="SETIEMBRE">SETIEMBRE</option>
                        <option value="AGOSTO">AGOSTO</option>
                        <option value="JULIO">JULIO</option>
                        <option value="JUNIO">JUNIO</option>
                        <option value="MAYO">MAYO</option>
                        <option value="ABRIL">ABRIL</option>
                        <option value="MARZO">MARZO</option>
                     </select>
                     <button className="modern-btn-primary">Filtrar</button>
                  </div>
               </div>

               <div className="convocatorias-grid">
                  {filteredData.map((item) => (
                     <div key={item.id} className="convocatoria-card glass-card">
                        <div className="card-header-status">
                           <span className={`status-badge ${item.status.toLowerCase().replace(" ", "-")}`}>
                              {item.status}
                           </span>
                        </div>
                        <div className="card-body-content">
                           <h3 className="convocatoria-title">CONVOCATORIA {item.number}</h3>
                           <div className="profiles-list mb-3">
                              {item.title.includes(') y (') 
                                 ? item.title.split(/\)\s*y\s*\(/).map((p, i) => (
                                     <div key={i} className="d-flex align-items-start mb-2">
                                        <i className="fa-solid fa-user-check mt-1 me-2 text-primary"></i>
                                        <h4 className="convocatoria-service mb-0" style={{fontSize: '15px'}}>{p.replace(/[\(\)]/g, '').trim()}</h4>
                                     </div>
                                   ))
                                 : <h4 className="convocatoria-service">{item.title}</h4>
                              }
                           </div>
                           <div className="period-box mb-4">
                              <i className="fa-regular fa-calendar me-2"></i> {item.period}
                           </div>

                           <div className="postulacion-box mb-4 p-3 bg-light rounded border-start border-4 border-warning" style={{fontSize: '14px'}}>
                              <div className="d-flex align-items-start">
                                 <i className="fa-solid fa-clock me-2 text-warning mt-1"></i>
                                 <div>
                                    <strong className="d-block mb-1">Postulación:</strong>
                                    <span>{item.Postulacion}</span>
                                 </div>
                              </div>
                           </div>

                           <div className="documents-grid">
                              <DocumentLink icon="fa-file-pdf" label="Bases" link={item.documents.bases} />
                              <DocumentLink icon="fa-list-check" label="Anexos." link={item.documents.verificacion} />
                              <DocumentLink icon="fa-pen-to-square" label="Resultados Evaluacion Curricular" link={item.documents.conocimientos} />
                              <DocumentLink icon="fa-users" label="Resultados Evaluacion Entrevista" link={item.documents.entrevista} />
                              <DocumentLink icon="fa-trophy" label="Resultado Final" link={item.documents.resultados} active={item.status === 'CONCLUIDO'} />
                              <DocumentLink icon="fa-clipboard-list" label="Observaciones" link={item.documents.observaciones} active={item.status === 'CONCLUIDO'} />
                           </div>
                        </div>
                     </div>
                  ))}
               </div>

            </div>
         </div>
      </>
   );
}

function DocumentLink({ icon, label, link, active = false }) {
   if (!link) {
      return (
         <div className="doc-item disabled">
            <div className="doc-icon"><i className={`fa-solid ${icon}`}></i></div>
            <span className="doc-label">{label}</span>
         </div>
      );
   }

   const isWord = link.toLowerCase().endsWith('.doc') || link.toLowerCase().endsWith('.docx');
   const fileIconClass = isWord ? "fa-file-word" : "fa-file-pdf";
   const fileIconColor = isWord ? "text-primary" : "text-danger";

   return (
      <a href={link} className={`doc-item ${active ? 'result-active' : ''}`} target="_blank" rel="noreferrer">
         <div className="doc-icon"><i className={`fa-solid ${icon}`}></i></div>
         <span className="doc-label">{label}</span>
         <div className={`mt-2 ${fileIconColor}`}><i className={`fa-solid ${fileIconClass} fa-lg`}></i></div>
      </a>
   );
}

export default ConvocatoriaCAS;
